<template>
  <section class="form__item__input input">
    <div class="form__row">
      <button class="button button--secondary input__button--subtle" @click.prevent="toggleHttp">Toggle to: {{ https ? 'http://' : 'https://' }}</button>
    </div>
    <input type="text" class="input__field" v-model="value" />
  </section>
</template>

<script>
  export default {
    name: 'LinkInput',
    components: {
    },
    props: ['settings', 'defaultValue'],
    methods: {
      update (value) {
        this.$emit('input', value)
      },
      toggleHttp () {
        this.https = !this.https
        let newerVal = this.value

        if (this.https) {
          newerVal = 'https://' + newerVal.split('http://').join('')
        } else {
          newerVal = 'http://' + newerVal.split('https://').join('')
        }

        this.value = newerVal
        this.update(newerVal)
      }
    },
    data () {
      return {
        value: this.defaultValue || null,
        valid: null,
        https: true
      }
    },
    watch: {
      value (newVal) {
        let newerVal = newVal.split('https://').join('')
        newerVal = newerVal.split('http://').join('')
        newerVal = newerVal.split('https://').join('')
        newerVal = newerVal.split('https:/').join('')
        newerVal = newerVal.split('http:/').join('')
        newerVal = newerVal.split('https/').join('')
        newerVal = newerVal.split('http/').join('')
        newerVal = newerVal.split('https:').join('')
        newerVal = newerVal.split('http:').join('')

        if (this.https) {
          newerVal = 'https://' + newerVal
        } else {
          newerVal = 'http://' + newerVal
        }

        this.update(newerVal)
        this.value = newerVal
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/configurator/LinkInput.vue